<template>
    <div :class="containerClass" @click="onDocumentClick($event)">
        <ConfirmPopup group="confirmPopup"/>
        <!-- Adding confirm dialog component in app for global access-->
        <!-- Remove this from other components later where not needed -->
        <ConfirmDialog />
        <AppTopBar :activeTopbarItem="activeTopbarItem" @menu-button-click="onMenuButtonClick($event)" @topbar-item-click="onTopbarItemClick"></AppTopBar>

        <div class="menu-wrapper" @click="onMenuClick($event)">
            <AppMenu v-if="isLoggedIn" :active="menuActive" :mobileMenuActive="staticMenuMobileActive" :menuMode="menuMode" @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
        </div>

        <div class="layout-main">
            <AppBreadcrumb></AppBreadcrumb>

            <div class="layout-content">
                <router-view />
            </div>

            <AppFooter></AppFooter>
        </div>

        <div v-if="staticMenuMobileActive" class="layout-mask modal-in"></div>
    </div>
</template>

<script>
import AppTopBar from './AppTopbar';
import AppMenu from './AppMenu';
import AppFooter from './AppFooter';
import AppBreadcrumb from './AppBreadcrumb';
import EventBus from './event-bus';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            menuTheme: 'dark',
            menuMode: 'static',
            activeTopbarItem: null,
            menuActive: false,
            overlayMenuActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            menuClick: false,
            userMenuClick: false,
            topbarMenuActive: false,
            screenTimeoutCheckInterval: process.env.VUE_APP_IDLE_CHECK_INTERVAL,
        };
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn']),
        containerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-static': this.menuMode === 'static',
                    'layout-overlay-active': this.overlayMenuActive,
                    'layout-mobile-active': this.staticMenuMobileActive,
                    'layout-static-active': !this.staticMenuDesktopInactive,
                },
                'layout-menu-dim layout-topbar-light',
            ];
        },
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    mounted() {
        // if(!this.userCompanyId && this.isGodUser){
        //     this.$toast.add({ severity: 'info', summary: 'Root Info', detail: 'Select a company before any operations', life: 3000 });
        // }

        // set the initial value of the lastActive state property

        // this.$store.dispatch('session/setLastActive', Date.now());

        // start the idle timeout checker
        // this.startIdleTimeoutChecker();
        // add event listeners to update lastActive state
        document.addEventListener('mousemove', this.updateLastActive);
        document.addEventListener('keydown', this.updateLastActive);
        document.addEventListener('click', this.updateLastActive);
    },
    beforeUnmount() {
        // remove event listeners
        document.removeEventListener('mousemove', this.updateLastActive);
        document.removeEventListener('keydown', this.updateLastActive);
        document.removeEventListener('click', this.updateLastActive);
    },
    methods: {
        onDocumentClick() {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.userMenuClick) {
                this.topbarMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isHorizontal()) {
                    EventBus.emit('reset-active-index');
                    this.menuActive = false;
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.hideOverlayMenu();
                }

                this.unblockBodyScroll();
            }
            this.topbarItemClick = false;
            this.menuClick = false;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onMenuButtonClick(event) {
            this.rotateMenuButton = !this.rotateMenuButton;
            this.topbarMenuActive = false;
            this.menuClick = true;

            if (this.isOverlay() && !this.isMobile()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event.preventDefault();
        },
        onMenuItemClick(event) {
            if (!event.item.items) {
                EventBus.emit('reset-active-index');
                this.hideOverlayMenu();
            }
            if (!event.item.items && this.isHorizontal()) {
                this.menuActive = false;
            }
        },
        onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onTopbarItemClick(event) {
            this.topbarItemClick = true;

            if (this.activeTopbarItem === event.item) {
                this.activeTopbarItem = null;
            } else {
                this.activeTopbarItem = event.item;
            }

            event.originalEvent.preventDefault();
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
            this.unblockBodyScroll();
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
        isTablet() {
            const width = window.innerWidth;
            return width <= 1024 && width > 640;
        },
        isDesktop() {
            return window.innerWidth > 992;
        },
        isMobile() {
            return window.innerWidth <= 640;
        },
        isOverlay() {
            return this.menuMode === 'overlay';
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        isHorizontal() {
            return this.menuMode === 'horizontal';
        },
        updateLastActive() {
            // this.$store.dispatch('session/setLastActive', Date.now());
        },
        startIdleTimeoutChecker() {
            this.intervalId = setInterval(() => {
                let timeDiff = this.$store.state.session.lastActive && Date.now() - this.$store.state.session.lastActive;
                let timeOut = this.$store.state.session.idleTimeout;
                if (timeDiff > timeOut) {
                    // this.$store.dispatch('auth/logout');
                    // this.$router.push('/login');
                    clearInterval(this.intervalId);
                }
            }, this.screenTimeoutCheckInterval * 60 * 1000); //checks every 10 minutes
        },
    },
    components: {
        AppTopBar,
        AppMenu,
        AppFooter,
        AppBreadcrumb,
    },
};
</script>

<style lang="scss">
@import 'App.scss';
.custom-loader {
    position: absolute;
    top: 50vh;
    right: 40vw;
    z-index: 1;
}
</style>
